import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/clientes',
    name: 'clientes.index',
    component: () => import('./views/ClientesIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'clientes.read',
      breadcrumb: 'Clientes',
    },
  },
]

export default routes
